import { showMainToast } from "./showToast";
export async function captureAvdm(device, wadh) {
    const doc = document.implementation.createDocument("", "", null);
    const pidOptionsElem = doc.createElement("PidOptions");
    pidOptionsElem.setAttribute("ver", "1.0");

    const optsElem = doc.createElement("Opts");
    optsElem.setAttribute("fCount", 1);
    optsElem.setAttribute("fType", 2);
    optsElem.setAttribute("iCount", 0);
    optsElem.setAttribute("pCount", 0);
    optsElem.setAttribute("format", 0);
    optsElem.setAttribute("pidVer", "2.0");
    optsElem.setAttribute("timeout", 10000);
    optsElem.setAttribute("posh", "UNKNOWN");
    optsElem.setAttribute("env", "P");
    optsElem.setAttribute("wadh", wadh);

    pidOptionsElem.appendChild(optsElem);

    const custOpts = doc.createElement("CustOpts");
    const param = doc.createElement("Param");
    param.setAttribute("name", "mantrakey");
    param.setAttribute("value", "");
    custOpts.appendChild(param);
    pidOptionsElem.appendChild(custOpts);

    doc.appendChild(pidOptionsElem);

    const xmlPayload = new XMLSerializer().serializeToString(doc);
    console.log("XML Payload:", xmlPayload);

    const finUrl =
        device === "morpho"
            ? "http://127.0.0.1:11100/capture"
            : "http://127.0.0.1:11100/rd/capture";

    try {
        const response = await fetch(finUrl, {
            method: "CAPTURE", // browsers reject nonstandard "CAPTURE"
            headers: { "Content-Type": "text/xml; charset=utf-8" },
            body: xmlPayload,
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const text = await response.text();
        const pidXml =
            device === "morpho"
                ? new XMLSerializer().serializeToString(
                    new DOMParser().parseFromString(text, "text/xml")
                )
                : text;
        showMainToast("Fingerprint captured successfully", 'success');
        console.log("Captured PID XML:", pidXml);
        return { success: true, data: pidXml };
    } catch (err) {
        showMainToast(`Fingerprint captured failed. ${err}`, 'danger');
        console.error("Fingerprint capture failed:", err);
        return { success: false, error: err.message };
    }
}
